import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ReviewUploadQuestionBlock" }
const _hoisted_2 = { class: "ReviewUploadTitle" }
const _hoisted_3 = ["name", "id", "value", "onChange", "checked"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("legend", _hoisted_2, _toDisplayString(_ctx.question.label), 1 /* TEXT */),
    (_ctx.isAnswerTypeMultiSelect)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.question.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.optionId
          }, [
            _createElementVNode("input", {
              type: "radio",
              name: `ReviewUploadQuestion${_ctx.question.questionId}`,
              class: "ReviewUploadRadioButton",
              id: `ReviewUploadQuestion${option.optionId}`,
              value: option.optionId,
              onChange: ($event: any) => (_ctx.storeQuestionAnswer(option.optionId, null)),
              checked: option.optionId === _ctx.answer?.optionId
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
            _createElementVNode("label", {
              for: `ReviewUploadQuestion${option.optionId}`,
              class: "ReviewUploadQuestionText"
            }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_4)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      : (_ctx.isAnswerTypeNumber)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ReviewUploadInputNote" }, " *If unknown, leave blank ", -1 /* CACHED */)),
            _createElementVNode("label", {
              class: "ReviewUploadQuestionText",
              for: `ReviewUploadQuestion${_ctx.question.questionId}`
            }, " Unique enrolments: ", 8 /* PROPS */, _hoisted_5),
            _createElementVNode("input", {
              type: "number",
              id: `ReviewUploadQuestion${_ctx.question.questionId}`,
              class: "ReviewUploadNumberInput",
              placeholder: "Insert number",
              value: _ctx.answer?.answerText || '',
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.storeQuestionAnswerNumber($event.target as HTMLInputElement)))
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
  ]))
}